<template>
  <div>
    <p>Liste des commissions</p>
    <div class="row text-left">
      <div
        v-for="(membership, index) in memberships"
        :key="index"
        class="col-md-6"
      >
        <div
          class="membership-card clickable-element"
          @click="committeeCardClicked(membership, $event)"
        >
          <b
            >{{ membership.committee.name }} ({{
              membership.committee.acronym
            }})</b
          ><br />
          Fonction:
          {{ membership.function ? membership.function.name : '-' }}<br />
          Notes: {{ membership.notes }}<br />
          Rôle:
          {{ membership.role ? membership.role.roleName : '-' }}<br />
          Rôle au bureau:
          {{
            membership.roleInCommitteeOffice
              ? membership.roleInCommitteeOffice.roleofName
              : '-'
          }}<br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommitteesCards',
  props: {
    memberships: Array,
  },
  methods: {
    committeeCardClicked(membership, event) {
      this.$router.push({
        name: 'CommitteeDetails',
        params: { id: membership.committee.id, newCommitteeCreation: false },
      });
    },
  },
};
</script>

<style scoped>
.membership-card {
  background-color: lightcoral;
  padding: 15px;
  border: none;
  border-radius: 5px;
  margin-bottom: 10px;
}
</style>
